import React from 'react';
import Popover from '@mui/material/Popover';
import { popoverStyle } from './viewMatchPopover.tailwind';
import view_scorer_page from "../../../../assets/svgs/view_scorer_page.svg";
import { useSelector } from 'react-redux';

// Popover
const ViewMatchPopover = ({ game, anchorEl, onClose, handleScoreGame, handleRestartGame, isLoading }) => {
    const open = Boolean(anchorEl);
    const id = open ? 'profile-popover' : undefined;
    const { restartingGame } = useSelector(state => state.liveGame);

    return (
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            disableScrollLock={true} //disables automatically scrolling-LOCK
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: "5px",
                        border: "1px solid #636B81",
                        backgroundColor: "rgba(2, 5, 41, 0.75)",
                        padding: "8px 15px", 
                        maxWidth: "240px",
                        '@media (max-width: 1024px)': {
                            padding: "7px 11px"
                        },
                    }
                }
            }}
        >
            {/* Popover Body */}
            <div className={popoverStyle.popoverContent}>
                {/* All Other tabs */}
                {game?.enableScorePage && (
                    <button className={popoverStyle.popoverButton} onClick={handleScoreGame}>
                        View Scorer Page
                        <img src={view_scorer_page} alt="Score Game" className={popoverStyle.score_game_icon} />
                    </button>
                )}
                {(game?.apiGameId && (game?.isGameEnded || game?.isDemo)) && (
                    <button className={popoverStyle.popoverButton} onClick={handleRestartGame} disabled={restartingGame || isLoading}>
                        {(restartingGame && isLoading) ? `Restarting...` : `Restart Game (For Demo) `}
                        <img src={view_scorer_page} alt="Score Game" className={popoverStyle.score_game_icon} />
                    </button>
                )}
            </div>
        </Popover>
    );
};

export default ViewMatchPopover;